var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"spinner"}),_c('div',{staticClass:"msg"},[_vm._v(_vm._s(_vm.$store.state.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }